import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";

@Component({
    selector: "app-global-search-table",
    styleUrls: ["./global-search-table.component.scss"],
    templateUrl: "./global-search-table.component.html",
})
export class GlobalSearchTableComponent implements OnChanges {
    
    @Input() isVisible;
    @Input() globalSearchData: any;
    @Input() fieldName: string;
    @Output() refresh = new EventEmitter();
    
    globalSearchCols = [
        {
        "field": "name",
        "header": "Name",
        }
    ];
    selectedGsProduct;


    constructor() {}
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.isVisible && changes.isVisible.currentValue) {
            this.isVisible = changes.isVisible.currentValue;
        }
        if (changes.globalSearchData && changes.globalSearchData.currentValue) {
            this.globalSearchData = changes.globalSearchData.currentValue;
            this.selectedGsProduct = this.globalSearchData && this.globalSearchData[0];
        }
        if (changes.fieldName && changes.fieldName.currentValue){
            let fieldName = changes.fieldName.currentValue;
            this.globalSearchCols[0].header = fieldName;
        }

    }

    refreshList(){
        this.refresh.emit({});
    }
}
